import { Controller } from "@hotwired/stimulus"

// Turns its element into a drag-and-drop target for a file <input> it contains
// (or a declared target). Dropped files are merged into the input's existing
// selection and a `change` event is fired, so a separate uploads/preview
// controller (e.g. `image-uploads`) can validate and render them. Drag-over
// styling is configurable via the `active` Stimulus class.
//
//   <label data-controller="file-dropzone"
//          data-action="dragover->file-dropzone#over dragleave->file-dropzone#leave drop->file-dropzone#drop"
//          data-file-dropzone-active-class="border-blue-500 bg-blue-50">
//     <input type="file" multiple data-file-dropzone-target="input">
//   </label>
export default class extends Controller {
  static targets = ["input"]
  static classes = ["active"]

  over(event) {
    event.preventDefault()
    if (this.hasActiveClass) this.element.classList.add(...this.activeClasses)
  }

  leave(event) {
    // dragleave also fires when the pointer crosses onto a child element;
    // ignore those so the highlight doesn't flicker while still over the zone.
    if (event?.relatedTarget && this.element.contains(event.relatedTarget)) return
    if (this.hasActiveClass) this.element.classList.remove(...this.activeClasses)
  }

  drop(event) {
    event.preventDefault()
    this.leave()

    const transfer = new DataTransfer()
    Array.from(this.input.files).forEach((file) => transfer.items.add(file))
    Array.from(event.dataTransfer.files).forEach((file) => transfer.items.add(file))
    this.input.files = transfer.files
    this.input.dispatchEvent(new Event("change", { bubbles: true }))
  }

  get input() {
    return this.hasInputTarget ? this.inputTarget : this.element.querySelector("input[type=file]")
  }
}
